module.exports = __webpack_public_path__ + "img/Penrose-Digital-Logo-White-01.fab1dab8.png";